import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PerformanceTile } from '@bingads-webui-campaign-react/performance-tile';
import {
  useAudienceReachEstimationV2,
} from '@bingads-webui-campaign-react/pmax-lite-data';

import { formatBigDecimal } from '../utils/format-big-decimal';
import { getEstimationAudienceValueV2, getFormattedTargetsPayload } from '../utils/audience-estimation';

export const TargetingEstimation = ({ data }) => {
  const i18n = useContext(I18nContext);

  const formattedTargets = useMemo(() => (
    getFormattedTargetsPayload(data, true)
  ), [data]);

  const [{
    isLoading: isRecommendationDataLoadingV2,
    data: estimationDataV2,
  }] = useAudienceReachEstimationV2(formattedTargets, !!data);

  const estimations = useMemo(() => {
    const estimationAudienceValue = getEstimationAudienceValueV2(estimationDataV2);
    if (estimationAudienceValue === 0) {
      return null;
    }
    return [{
      className: 'audience-reach',
      title: i18n.getString(_TL_('Audience size')),
      dashColor: '#00188F',
      estimation: formatBigDecimal(estimationAudienceValue, i18n),
    }];
  }, [estimationDataV2, i18n]);

  return (
    <PerformanceTile
      className="estimate-reach"
      heading={i18n.getString(_TL_('Estimated monthly performance'))}
      description={i18n.getString(_TL_('These are estimates based on businesses with similar ad settings.'))}
      note={i18n.getString(_TL_('These are estimated figures and do not guarantee future results.'))}
      estimations={estimations}
      showShimmer={isRecommendationDataLoadingV2}
    />
  );
};

TargetingEstimation.propTypes = {
  data: PropTypes.shape({}),
};

TargetingEstimation.defaultProps = {
  data: undefined,
};
